import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  BorderDashStyle_Dashed_instance = new (BorderDashStyle())('Dashed', 0, 'dashed');
  BorderDashStyle_Dotted_instance = new (BorderDashStyle())('Dotted', 1, 'dotted');
}
var BorderDashStyle_Dashed_instance;
var BorderDashStyle_Dotted_instance;
var BorderDashStyleClass;
function BorderDashStyle() {
  if (BorderDashStyleClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, cssValue) {
        super(name, ordinal);
        this.cssValue_1 = cssValue;
      }
    }
    initMetadataForClass($, 'BorderDashStyle');
    BorderDashStyleClass = $;
  }
  return BorderDashStyleClass;
}
function BorderDashStyle_Dashed_getInstance() {
  static_init();
  return BorderDashStyle_Dashed_instance;
}
//region block: exports
export {
  BorderDashStyle_Dashed_getInstance as BorderDashStyle_Dashed_getInstance2gd3qu91rajbi,
};
//endregion

//# sourceMappingURL=DashedBorder.mjs.map
